export default "__VITE_ASSET__15836d74__"